import { SEND_NOTIFICATION_SUCCESS, SEND_NOTIFICATION_ERROR } from '../actionConstants/notificationConstants';

export const sendNotificationSuccess = ({ message }) => ({ type: SEND_NOTIFICATION_SUCCESS, payload: { message } });
// this action emulate server side error, save old name for simplify use
export const sendNotificationError = ({ message, title, status, buttonText, linkURL }) => ({
  type: SEND_NOTIFICATION_ERROR,
  payload: { message, title, status, buttonText, linkURL },
});
